<template>
  <div>
    <z-centralized-toolbar>
      <!-- <v-toolbar-items> -->
        <v-btn
          depressed
          rounded
          color="primary"
          :to="{ name: 'ProdutosAdicionar' }"
          :disabled="$store.state.loading"
        >
          <v-icon left>mdi-plus</v-icon>
          Adicionar Produto
        </v-btn>

        <v-btn
          text
          outlined
          rounded
          :disabled="$store.state.loading"
          @click="$refs.dialogoImpressaoProdutos.abrir()"
        >
          <v-icon left>mdi-printer</v-icon>
          Imprimir
        </v-btn>

        <v-btn
          icon
          id="btn_atualizar"
          text
          :ripple="false"
          :loading="$store.state.loading"
          @click="refresh"
        >
          <v-icon>mdi-refresh</v-icon>
          <v-tooltip bottom activator="#btn_atualizar">Atualizar</v-tooltip>
        </v-btn>
      <!-- </v-toolbar-items> -->
      <!-- <v-spacer></v-spacer> -->
      <z-text-field-search 
        v-model="search"
        select 
        class="ml-5"
        show-type
        @keydown.enter="refresh" 
        @click:clear="limparBusca"
        @change:type="value => {$store.state.produtos.search_type = value; refresh()}"
      ></z-text-field-search>

      <v-btn-toggle
        v-if="false"
        v-model="listagem"
        mandatory
        color="primary"
      >
        <v-btn value="Recentes" small>
          Recentes
        </v-btn>
        <v-btn value="Todos" small>
          Todos
        </v-btn>
      </v-btn-toggle>
    </z-centralized-toolbar>
    
    <z-container>
      <h3 class="text-body-1 mb-3">Produtos</h3>

      <v-card>
        <v-data-table
          disable-pagination
          :hide-default-footer="hideDefaultFooter"
          disable-sort
          single-expand
          id="movimentos"
          item-key="id"
          :headers="headers"
          :items="produtos"
          :loading="false"
          :options.sync="options"
          :server-items-length="total_de_registros"
          :footer-props="$globals.FOOTER_PROPS"
        >
          <template v-slot:item="props">
            <tr style="cursor: pointer" @click="props.expand(!props.isExpanded)">
              <td class="text-no-wrap">{{ props.item.referencia }}</td>
              <td>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title style="font-size: 14px;">
                      {{ props.item.descricao }}
                      <v-chip x-small color="red" dark v-if="props.item.ativo == 0">Inativo</v-chip>
                    </v-list-item-title>
                    <v-list-item-subtitle class="d-flex" style="gap: 5px" v-if="props.item.variacoes">
                      <v-chip 
                        v-for="(variacao, index) in props.item.variacoes"
                        :key="index"
                        x-small 
                        color="grey lighten-2"
                      >{{ variacao.descricao }}</v-chip>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </td>
              <td>
                <span v-if="props.item.grupo">{{ props.item.grupo.descricao }}</span>
              </td>
              <td class="text-right">
                {{ props.item.estoque ? props.item.estoque.estoque : 0 }} {{ props.item.unidade }}
              </td>
              <td class="text-right">{{ props.item.valor_venda | valorBR }}</td>
              <td class="text-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      class="ma-0"
                      @click.stop="dialogoHistorico(props.item)"
                    >
                      <v-icon> mdi-view-list </v-icon>
                    </v-btn>
                  </template>
                  Histórico
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      class="ma-0"
                      @click.stop="imprimirEtiqueta(props.item)"
                    >
                      <v-icon>mdi-tag</v-icon>
                    </v-btn>
                  </template>
                  Imprimir Etiquetas
                </v-tooltip>
                <!-- <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      class="ma-0"
                      @click.stop="dialogoAjusteEstoque(props.item)"
                    >
                      <v-icon>tune</v-icon>
                    </v-btn>
                  </template>
                  Ajustar Estoque
                </v-tooltip> -->
                <v-btn icon class="ma-0" @click.stop="editar(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  icon
                  class="ma-0"
                  @click.stop="perguntarExcluir(props.item)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>

          <template v-slot:expanded-item="{ item, headers }">
            <tr>
              <td :colspan="headers.length" class="pa-4 grey lighten-3">
                <v-row dense>
                  <v-col cols="12">
                    <v-card>

                      <v-data-table 
                        hide-default-footer 
                        disable-pagination
                        disable-sort
                        dense
                        item-key="id" 
                        :headers="headers_fornecedores" 
                        :items="item.fornecedores"
                        no-data-text="Nenhum fornecedor encontrado"
                      ></v-data-table>
                    </v-card>

                  </v-col>
                </v-row>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </z-container>

    <z-dialogo
      ref="dialogoExcluir"
      titulo="Deseja excluir esse produto?"
      :dividers="true"
      largura="500px"
    >
      <div slot="texto">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Referência</v-list-item-subtitle>
              <v-list-item-title>{{ produto.referencia }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Descrição</v-list-item-subtitle>
              <v-list-item-title>{{ produto.descricao }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>

      <v-btn text @click="$refs.dialogoExcluir.fechar()" :disabled="excluindo"
        >Cancelar</v-btn
      >
      <v-btn
        color="primary darken-1"
        text
        :loading="excluindo"
        :disabled="excluindo"
        @click="confirmarExcluir"
        >Excluir</v-btn
      >
    </z-dialogo>

    <z-dialogo
      ref="dialogoAjusteEstoque"
      titulo="Ajuste de Estoque"
      largura="750px"
      :dividers="true"
    >
      <div slot="texto">
        <v-form class="v-form">
          <v-row dense>
            <v-col sm="12">
              <v-text-field
                label="Produto"
                readonly
                filled
                dense
                :value="produto.descricao"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <z-campo-valor
                v-model="produto.estoque"
                label="Estoque Atual"
                readonly
                filled
                dense
                :decimais="0"
              ></z-campo-valor>
            </v-col>
            <v-col sm="4">
              <z-campo-valor
                v-model="produto.novoestoque"
                label="Novo Estoque"
                ref="novoestoque"
                filled
                dense
                :decimais="0"
              ></z-campo-valor>
            </v-col>
          </v-row>
        </v-form>
      </div>

      <v-btn
        text
        :disabled="loading"
        @click="$refs.dialogoAjusteEstoque.fechar()"
        >Cancelar</v-btn
      >
      <v-btn
        color="primary"
        depressed
        :loading="loading"
        :disabled="loading"
        @click="confirmarAjuste"
        >Ajustar</v-btn>
    </z-dialogo>

    <historico-produto ref="dialogoHistorico"></historico-produto>

    <DialogoImpressaoProdutos ref="dialogoImpressaoProdutos"></DialogoImpressaoProdutos>

    <modelo-etiqueta
      ref="dialogoModeloEtiqueta"
      :exibir-quantidade="true"
    ></modelo-etiqueta>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import qs from "qs";
import config from "@/app/config";

import ModeloEtiqueta from "@/pages/produtos/etiquetas/ModeloEtiqueta.vue";
import HistoricoProduto from "./historico/HistoricoProduto";
import DialogoImpressaoProdutos from "./DialogoImpressaoProdutos.vue";

export default {
  name: "ProdutosLista",
  components: {
    HistoricoProduto,
    ModeloEtiqueta,
    DialogoImpressaoProdutos
  },
  data() {
    return {
      // globals,
      headers: [
        { text: "Referência", value: "referencia", width: "100px" },
        // { text: "Entradas", value: "lote_id", align: 'center', width: "100px" },
        { text: "Descrição", value: "descricao" },
        { text: "Grupo", value: "grupo", sortable: false },
        { text: "Estoque", value: "estoque", align: "right" },
        { text: "Valor Venda", value: "valor_venda", align: "right" },
        { text: "Opções", value: "", width: "200px", align: "center", sortable: false },
      ],
      headers_fornecedores: [
        { text: "Id", value: "id", width: "100px" },
        { text: "Nome", value: "razao" },
        { text: "Celular", value: "celular"},
      ],
      excluindo: false,
      loading: false,
      produto: {
        id: '',
      },
      listagem: "Recentes",
      produto: {
        id: "",
        referencia: "",
        descricao: "",
        estoque: "",
        novoestoque: "0",
      },
      ordenar_por: [
        { text: "Referência", value: "referencia" },
        { text: "Descrição", value: "descricao" },
      ],
      imprimir: {
        impressao: "estoque",
        ordenar_por: "referencia",
        estoquezerado: 0,
        loja_id: 0,
      },
      FOOTER_PROPS: {
        "items-per-page-options": [10, 15, 20, 30, 50],
      },
      hideDefaultFooter: false,
      filtro: "Contém",
    };
  },

  inject: ["$imprimir"],

  computed: {
    ...mapState("produtos", ["produtos", "pagination", "total_de_registros"]),
    ...mapState("lojas", ["loja_atual"]),

    search: {
      get() {
        return this.$store.state.produtos.search;
      },
      set(search) {
        this.$store.commit("produtos/SET_SEARCH", search);
      },
    },

    options: {
      get() {
        return this.$store.state.produtos.pagination;
      },
      set(options) {
        this.$store.commit("produtos/UPDATE_PAGINATION", options);
      },
    },
  },

  beforeRouteLeave(to, from, next) {
    if (["ProdutosAdicionar", "ProdutosEditar"].indexOf(to.name) == -1) {
      this.$store.commit("produtos/SET_PAGE", 1);
      this.$store.commit("produtos/SET_SEARCH", "");
      // this.refresh();
    }
    next();
  },

  created() {
    this.setTitulo("Cadastro de Produtos");
    // this.listar();
  },

  mounted() {
    this.imprimir.loja_id = this.loja_atual.id;
  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),
    ...mapActions("produtos", ["listar", "excluir", "abrir", "ajustar"]),

    async refresh() {
      try {
        if (!!this.search) {
          this.hideDefaultFooter = true;
        } else {
          this.hideDefaultFooter = false;
        }
        
        await this.listar();
      } catch (error) {
        this.$eventbus.erro("Não foi possível obter a lista de produtos.", error);
        this.LOADING_OFF();
        throw error;
      }
    },

    async editar(produto) {
      await this.abrir(produto.id);
      await this.$store.dispatch('produtos/variacoes', produto.id);
      this.$router.push({ name: "ProdutosEditar", params: { id: produto.id } });
    },

    dialogoHistorico(produto) {
      // this.$router.push({
      //   name: "ProdutosHistorico",
      //   params: { id: produto.id },
      // });

      this.$store.commit('produtos/SET_PRODUTO', produto);
      this.$refs.dialogoHistorico.abrir();
    },

    dialogoAjusteEstoque(produto) {
      this.produto = {
        id: produto.id,
        referencia: produto.referencia,
        descricao: produto.referencia + " - " + produto.descricao,
        estoque: produto.estoque,
        novoestoque: "0",
      };
      this.$refs.dialogoAjusteEstoque.abrir();
      this.setFocus("novoestoque");
    },

    async confirmarAjuste() {
      try {
        this.loading = true;
        await this.ajustar(this.produto);
        this.$refs.dialogoAjusteEstoque.fechar();
      } catch (error) {
        this.$eventbus.erro("Não foi possível ajustar o estoque desse produto.", error);
      } finally {
        this.loading = false;
      }
    },

    perguntarExcluir(produto) {
      this.produto = produto;
      this.$refs.dialogoExcluir.abrir();
    },

    async confirmarExcluir() {
      try {
        this.excluindo = true;
        await this.excluir(this.produto.id);
      } finally {
        this.$refs.dialogoExcluir.fechar();
        this.excluindo = false;
        this.$eventbus.notificar("Produto excluído com sucesso!");
      }
    },

    limparBusca() {
      this.search = "";
      this.hideDefaultFooter = false;
      this.$store.commit("produtos/SET_PAGE", 1);
      this.refresh();
    },

    confirmarImprimir() {
      this.$imprimir("relatorios/produtos/imprimir?" + new URLSearchParams(this.imprimir).toString(), "relatorio_de_produtos.pdf");
    },

    async imprimirEtiqueta(item) {
      const { modelo, quantidade } = await this.$refs.dialogoModeloEtiqueta.abrir();

      if (!modelo) {
        return;
      }

      const produto = {
        id: item.id,
        quantidade: quantidade,
      };

      await this.$axios.post("/etiquetas/produtos", {
        modelo,
        produtos: [produto],
      });
    },
  },



  watch: {
    options: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
